import { computed, useSignal } from '@preact/signals'
import { useEffect } from 'preact/hooks'

import { CreateDAppFromTemplate } from 'components/template'

import {
	createDAppFromTemplate,
	dAppDescriptionState,
	dAppNameState,
	getTemplates,
	formErrors,
	isDAppLoading,
	setDAppDescription,
	setDAppName,
	selectedTemplateState,
	setSelectedTemplate,
	resetDAppForm,
	type Template
} from './state'

const LOADING_USE_CASES: Template[] = Array.from({ length: 12 }, (_, i) => ({
	id: i.toString(),
	name: '&nbsp;',
	subtitle: '&nbsp;',
	description: '&nbsp;'
}))

const isButtonDisabled = computed(
	() =>
		dAppNameState.value === '' ||
		isDAppLoading.value ||
		!!formErrors.value.name ||
		!!formErrors.value.description
)

const CreateDAppFromTemplatePage = () => {
	const hideAdditionalTemplates = useSignal(true)
	const isLoading = useSignal(true)
	const templates = useSignal<Template[]>(LOADING_USE_CASES)
	const templatesFiltered = useSignal<Template[]>(LOADING_USE_CASES)

	useEffect(() => {
		getTemplates().then(data => {
			templates.value = data!
			templatesFiltered.value = data!
			isLoading.value = false
		})
	}, [isLoading, templates, templatesFiltered])

	useEffect(() => () => resetDAppForm(), [])

	return (
		<CreateDAppFromTemplate
			createDAppFromTemplate={createDAppFromTemplate}
			dAppDescription={dAppDescriptionState}
			dAppName={dAppNameState}
			filteredTemplates={templatesFiltered}
			formErrors={formErrors}
			handleTemplateSelection={setSelectedTemplate}
			hideAdditionalTemplates={hideAdditionalTemplates}
			isButtonDisabled={isButtonDisabled}
			isLoading={isLoading}
			selectedTemplate={selectedTemplateState}
			updateDAppDescription={setDAppDescription}
			updateDAppName={setDAppName}
		/>
	)
}

export { CreateDAppFromTemplatePage }
